<template>
  <h3 class="dal-slider-title">
    <slot></slot>
  </h3>
</template>

<script>
export default {
  name: 'DalSliderTitle'
}
</script>

<style lang="scss" scoped>
.dal-slider-title {
  font-size: 32px;
  text-align: left;
  color: #ffffff;
  font-weight: $fw-bold;
}
</style>



// WEBPACK FOOTER //
// src/components/dal/DalSliderTitle.vue